import * as React from 'react';
import { Section } from '../../../../../SectionV2';
import { CloudMigrationResource } from './CloudMigrationResource';
import { ResourceList } from './styles';
import { AtlassianCommunityResource, DocumentationResource, ForumsResource, IssueTrackerResource, StatusPageResource } from './SupportResource';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SupportResources = props => {
  const {
    supportDetails: {
      resources: {
        documentationUrl,
        forumsUrl
      },
      contact: {
        statusPageUrl,
        issueTrackerUrl
      }
    },
    onSupportLinkClick,
    atlassianCommunityUrl,
    onCloudMigrationResourceLinksClick,
    cloudMigrationInfo
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Section.Heading, {
      as: "h3",
      children: "Help resources"
    }), /*#__PURE__*/_jsxs(ResourceList, {
      children: [/*#__PURE__*/_jsx(CloudMigrationResource, {
        cloudMigrationInfo: cloudMigrationInfo,
        onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick
      }), /*#__PURE__*/_jsx(DocumentationResource, {
        documentationUrl: documentationUrl,
        onSupportLinkClick: onSupportLinkClick
      }), /*#__PURE__*/_jsx(ForumsResource, {
        forumsUrl: forumsUrl,
        onSupportLinkClick: onSupportLinkClick
      }), /*#__PURE__*/_jsx(AtlassianCommunityResource, {
        atlassianCommunityUrl: atlassianCommunityUrl,
        onSupportLinkClick: onSupportLinkClick
      }), /*#__PURE__*/_jsx(StatusPageResource, {
        statusPageUrl: statusPageUrl,
        onSupportLinkClick: onSupportLinkClick
      }), /*#__PURE__*/_jsx(IssueTrackerResource, {
        issueTrackerUrl: issueTrackerUrl,
        onSupportLinkClick: onSupportLinkClick
      })]
    })]
  });
};